export default {
  back: '戻る',
  jewelUnit: 'ジュエル',
  apiError: '{message} [{code}]',
  app: {
    fetchingServerConstants: '設定を読み込んでいます...',
    fetchServerConstantsError: '設定を読み込めませんでした。この画面を再読み込みしてください。',
    loggedIn: 'ログインしました。',
    loggedOut: 'ログアウトしました。',
    terms: '利用規約'
  },
  navigationBar: {
    siteTitle: 'トピア ジュエル交換',
    login: 'ログイン',
    logout: 'ログアウト'
  },
  notFound: {
    title: 'ページが見つかりません',
    description: 'お探しのページが見つかりませんでした。',
    confirmURL: 'URLが誤っている可能性があります。お確かめの上、改めてアクセスしてください。',
    backToTop: 'トップページへ戻る'
  },
  auth: {
    loginWithTwitter: 'Twitterログイン',
    loginWithTwitterOrGoogle: 'TwitterまたはGoogleアカウントでログイン',
    pleaseLogin: 'アプリ版トピアで連携済のTwitterアカウントまたはGoogleアカウントでログインしてください。',
    doLoginWithTwitter: 'Twitterでログイン',
    doLoginWithGoogle: 'Googleでログイン',
    loginEndpoint: '※ログイン先:',
    exchangeNote: {
      prefix: '',
      link: 'ジュエル交換に関する注意事項',
      suffix: 'を必ずご確認ください。'
    }
  },
  authCallback: {
    login: 'ログイン',
    accountNotFound: 'TwitterアカウントまたはGoogleアカウントに紐付いたトピアアカウントが見つかりませんでした。',
    pleaseConfirmLogin: 'アカウント連携を再度ご確認いただき、もう一度お試しください。',
    autoRedirectNote: {
      beforeLink: 'Twitterアカウントを使用する場合で、トピアで連携済みのものと異なるアカウントで自動的にログインされてしまう場合は、',
      linkLabel: 'twitter.com',
      afterLink: 'にアクセスし、Twitterでログアウトしてから再度お試しください。'
    },
    cancelled: 'ログインが中止されました。',
    lackOfParameter: '予期しないエラーが発生しました。パラメータが不足しています。',
    noAccessToken: '予期しないエラーが発生しました。アクセストークンがありません。',
    unknownError: '不明なエラーが発生しました。もう一度お試しください。',
    backToLogin: 'ログイン画面に戻る'
  },
  home: {
    loginRequired: 'ログインしてください。',
    dashboard: 'ダッシュボード',
    jewelHistories: '履歴',
    jewelHistoryTable: {
      loading: '読み込み中...',
      refresh: '更新',
      acquiredAt: '{date}分',
      exchangedAt: '{date}に振込済み',
      noHistories: '履歴がありません',
      error: '履歴の読み込みに失敗しました。もう一度お試しください。',
      transactionType: {
        acquire: '獲得',
        exchangeRequest: '換金申請',
        expire: '換金期限切れ',
        coinExchange: 'コインへの交換'
      }
    },
    currentJewelInfo: {
      balance: '現在の残高',
      refresh: '更新',
      error: '残高の読み込みに失敗しました。もう一度お試しください。',
      registerBankAccount: {
        prefix: '口座情報の登録がお済みでない方は、まず最初に',
        link: '口座情報登録',
        suffix: 'を行ってください。'
      },
      exchangeNote: {
        prefix: '',
        link: 'ジュエル交換に関する注意事項',
        suffix: 'を必ずご確認ください。'
      },
      exchangeRequirement: '交換申請は{leastRequiredBalance}ジュエル以上から、{requiredStep}ジュエル単位で可能です。',
      dueDateNote: '交換申請された内容は毎月月末に締め、翌月15日の金融機関営業時間に、登録された口座へ振込を行います。',
      dueDatePrecautions1: '※土日祝日に該当する場合は直前の平日に前倒しされます。',
      dueDatePrecautions2: '※口座情報に問題がない場合、振込日当日の15時までに振込手続きがおこなわれます。',
      doRequest: '交換を申請する'
    }
  },
  requestExchange: {
    title: '交換申請',
    loading: '残高を読み込み中...',
    currentBalanceIs: '現在の残高: ',
    error: '残高の読み込みに失敗しました。',
    reload: '再読込',
    inputAmountYouWantToExchange: '交換したいジュエルの額を入力してください。',
    inputError: {
      gte: '{num} 以上を入力してください。',
      lte: '{num} 以下を入力してください。',
      multiple: '{num} {unit}単位にしてください。'
    },
    confirm: '確認する'
  },
  requestExchangeConfirm: {
    title: '交換申請の確認',
    amountToExchange: '交換する残高:',
    balanceAfterExchange: '交換後の残高:',
    currentBalance: '現在の残高 *',
    formulaAmountToExchange: '交換分',
    subtractedBalance: '交換後の残高 *',
    mayNotBeLatest: '* 最新の残高情報を反映していない場合があります。',
    areYouSure: 'この内容で交換を申請しますか？',
    doCorrect: '修正する',
    doRequest: '交換を申請する',
    submitting: '送信しています...',
    error: 'エラーが発生しました。しばらく経ってからもう一度お試しください。'
  },
  requestExchangeComplete: {
    title: '交換申請完了',
    done: '交換申請を受け付けました。',
    backToTop: 'ダッシュボードに戻る'
  }
}
